import { request } from './repository';

const url = 'groups/';

const groupStore = {
    storeGroup(data) {
        return request.post(url, data);
    },
    updateGroup(id, data) {
        return request.put(url + id, data);
    },
    deleteGroup(id) {
        return request.delete(url + id);
    },
    reorderGroups(data) {
        return request.post(url + 'reorder', data);
    },
}

export default groupStore;
